import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/games/path-of-exile-2-boost/currencies/divine_orb.webp")